import { useEffect, useState } from "react";

export const checkIsMobile = () => {
  if (typeof window === "undefined") return false;

  const userAgent =
    navigator.userAgent || navigator.vendor || window.opera || "";

  // Mobile User Agent detection
  const isMobileUA =
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  // Screen width threshold for mobile devices (< 768px)
  const isSmallScreen = window.innerWidth < 768;

  // In landscape mode on mobile phones, width might be wider but screen height is small
  const isMobileLandscape =
    isMobileUA ||
    (window.innerHeight <= 500 &&
      window.innerWidth <= 1024 &&
      Boolean(navigator.maxTouchPoints && navigator.maxTouchPoints > 0));

  return isMobileUA || isSmallScreen || isMobileLandscape;
};

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(checkIsMobile);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(checkIsMobile());
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
